import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import {formatDate} from 'utils/datetime';

import {
  SCHEDULE_ITEM_TYPES,
  SCHEDULE_TYPES_HUMAN_VALUES,
  SCHEDULE_TYPES
} from 'ducks/tenancy';

import Alert from 'components/Alert';
import Table from 'components/Table';
import Money from 'components/Money';
import CreditNoteStatusTag from 'components/CreditNoteStatusTag';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

const CreditNoteRow = ({
  creditNote,
  handleRowClick,
  redirectToBookingDetail,
  advancedMode
}) => {
  const {creditNoteDetails} = creditNote;

  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: creditNote.highlighted
      })}
      onClick={() =>
        handleRowClick({
          item: SCHEDULE_ITEM_TYPES.CREDIT_NOTE,
          itemId: creditNote.id,
          scheduleType: SCHEDULE_TYPES[creditNote.scheduleType],
          tenancyId: creditNoteDetails.tenancyId
        })
      }>
      <Table.Cell className="booking">
        <ClickIconWithNoPropagation
          onClick={() =>
            redirectToBookingDetail({bookingId: creditNote.bookingId})
          }>
          <div className="colab-bold">#{creditNote.bookingId}</div>
        </ClickIconWithNoPropagation>
      </Table.Cell>
      <Table.Cell className="date">{formatDate(creditNote.date)}</Table.Cell>
      {advancedMode && <Table.Cell className="dueDate" />}
      <Table.Cell className="type">
        <div className="colab-centered-v">
          {creditNoteDetails.hasXeroErrors && <Alert />}
          <div className="colab-centered-v">Credit Note</div>
        </div>
      </Table.Cell>
      <Table.Cell className="description">
        {creditNoteDetails.description}
      </Table.Cell>
      <Table.Cell className="category">
        {_.get(SCHEDULE_TYPES_HUMAN_VALUES, creditNote.scheduleType)}
      </Table.Cell>
      <Table.Cell className="status">
        <CreditNoteStatusTag
          status={creditNoteDetails.status}
          label={creditNoteDetails.status}
        />
      </Table.Cell>
      <Table.Cell className="amount due">
        <Money
          amount={-creditNote.amount}
          balance
          className={classNames({
            strikeThrough: creditNoteDetails.voided
          })}
        />
      </Table.Cell>
      {advancedMode && <Table.Cell className="payment" />}
      <Table.Cell className="balance">
        <Money amount={creditNote.balance} balance />
      </Table.Cell>
      <Table.Cell className="mode" />
    </Table.Row>
  );
};

export default CreditNoteRow;
